import { render, staticRenderFns } from "./SidebarToggleAlphaMod.vue?vue&type=template&id=6f0d32ec"
import script from "./SidebarToggleAlphaMod.vue?vue&type=script&lang=js"
export * from "./SidebarToggleAlphaMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports